import clsx from 'clsx'
import React from 'react'

type Props = {
  title: string | any
  children?: React.ReactNode
  className?: string
  subTitle?: string
}

export const Header: React.FC<Props> = ({title, children, className, subTitle}) => {
  return (
    <div className={clsx('card-header', className)}>
      <div className='d-flex align-items-center position-relative my-1'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label mb-1'>
            <div className='d-flex align-items-center mb-0 pb-0'>{title}</div>{' '}
            {subTitle && <span className='text-muted mt-1 fw-bold fs-7'>{subTitle}</span>}
          </span>
        </h3>
      </div>
      {children && <div className='card-toolbar'>{children}</div>}
    </div>
  )
}

export default Header
